import { Formik } from 'formik';
import React, { Component } from 'react';
import { Alert, Button, Card, CardBody, Col, FormFeedback, FormGroup, Input, Label, Row } from 'reactstrap';
import PropTypes from 'prop-types'
import * as Yup from 'yup';
import axios from 'axios'
import {toast} from 'react-toastify'
import 'react-select/dist/react-select.css';
import { TRANSPORTER_DELIVERY_CONFIRMATION_APPROVE_URL } from '../../../redux/config/links';
import { SelectField } from '../../Widgets/SelectField';
import Recaptcha from "react-recaptcha";

const validationSchema = Yup.object().shape({
    approval_name: Yup.string()
    .required('Name is required!'),
    approval_remark: Yup.string()
    .notRequired(),
    status_delivery: Yup.object()
    .shape({
      label: Yup.string(),
      value: Yup.number()
    })
    .nullable()
    .required("Location is required"),
    recaptcha: Yup.string().required(),
})

const propTypes = {
    id_do: PropTypes.number,
    id_wo: PropTypes.number,
    customerApprovalStatus: PropTypes.string,
    fetchDelivery: PropTypes.func,
    share_data: PropTypes.string
}

const defaultProps= {
    id_do: 0,
    id_wo: 0,
    customerApprovalStatus: false,
    share_data: ''
}

class DeliveryConfirmationForms extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            initialValues: {
                approval_name: '',
                approval_remark: '',
                status_delivery: {
                    label: '--  Please select  --',
                    value: 0
                }
            }
        };
    }

    componentDidMount() {
        const script = document.createElement("script");
        script.src =
        "https://www.google.com/recaptcha/api.js";
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
    }

    showForms = () => {
        return (
            <div>
                <Formik
                    initialValues={this.state.initialValues}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                        var self = this;
                        // var loginCreds = JSON.parse(window.atob(localStorage.Automalt));
                        // var auth = loginCreds.token;
                        setSubmitting(true)

                        axios({
                            method: 'post',
                            url: TRANSPORTER_DELIVERY_CONFIRMATION_APPROVE_URL,
                            headers: {
                                // Authorization: auth
                            },
                            data: {
                                id_delivery_order: self.props.id_do,
                                id_work_order: self.props.id_wo,
                                name: values.approval_name,
                                remarks: values.approval_remark,
                                status_delivery: values.status_delivery.value,
                                recaptcha: values.recaptcha,
                            }
                        })
                        .then((response) => {
                            if(response.status === 200){
                                if (response.data.status === "success"){
                                    setSubmitting(false)
                                    self.props.fetchDelivery(self.props.share_data)
                                    resetForm()
                                    return toast.success('You have record the delivery successfully!')
                                }
                            }
                        })
                        .catch(function(error){
                            if (error.response) {
                                if(error.response.status === 401) {
                                    setSubmitting(false)
                                    return toast.error("Invalid credentials! Please try again!");
                                } else if (error.response.status === 403) {
                                    setSubmitting(false)
                                    return toast.error("Unauthorized Access! Please try to logout..");
                                } else if (error.response.status === 400) {
                                    setSubmitting(false)
                                    return toast.error(error.response.data.error.message);
                                } else if (error.response.status === 404 || error.response.status === 500) {
                                    setSubmitting(false)
                                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                                } else {
                                    setSubmitting(false)
                                    return toast.error('Something went wrong... Please try again later...')
                                }
                            } else if (error.request) {
                                setSubmitting(false)
                                return toast.error('Request error! Please try again later...')
                            } else {
                                setSubmitting(false)
                                return toast.error('Something went wrong... Please try again later...')
                            }
                        })
                    }}
                    validationSchema={validationSchema}
                    render={({
                    values,
                    errors,
                    touched,
                    setFieldValue,
                    setFieldTouched,
                    handleSubmit,
                    handleBlur,
                    handleChange,
                    // handleReset,
                    // setTouched,
                    isValid,
                    isSubmitting
                    }) => (
                    <form>
                        <FormGroup row>
                            <Col md="12">
                                You will record your delivery confirmation. Here are the details:
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Col md="3">
                                <Label htmlFor="text-input">Your name</Label>
                            </Col>
                            <Col md="9">
                                <Input 
                                    type="text"
                                    name="approval_name"
                                    id="approval_name"
                                    placeholder="Your name ex. Joe"
                                    autoComplete={false}
                                    valid={!errors.approval_name}
                                    invalid={touched.approval_name && !!errors.approval_name}
                                    required
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.approval_name} 
                                    disabled={isSubmitting}
                                />
                            <FormFeedback>{errors.approval_name}</FormFeedback>
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Col md="3">
                                <Label htmlFor="text-input">Delivery Status</Label>
                            </Col>
                            <Col xs="12" md="9">
                                <SelectField
                                    id="status_delivery"
                                    name="status_delivery"
                                    label="status_delivery"
                                    placeholder="Select delivery status"
                                    options={this.props.deliveryStatusListData}
                                    value={values.status_delivery}
                                    isMulti={false}
                                    onChange={setFieldValue}
                                    onBlur={setFieldTouched}
                                    touched={touched.status_delivery}
                                    error={errors.status_delivery}
                                    isClearable={true}
                                    backspaceRemovesValue={true}
                                    disabled={isSubmitting}
                                />
                            <FormFeedback>{errors.status_delivery}</FormFeedback>
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Col md="3">
                                <Label htmlFor="text-input">Remark</Label>
                            </Col>
                            <Col md="9">
                                <Input 
                                    type="textarea"
                                    rows="3"
                                    name="approval_remark"
                                    id="approval_remark"
                                    placeholder="Remark for the delivery ex. delivery confirmed"
                                    autoComplete={false}
                                    valid={!errors.approval_remark}
                                    invalid={touched.approval_remark && !!errors.approval_remark}
                                    required
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.approval_remark} 
                                    disabled={isSubmitting}
                                />
                            <FormFeedback>{errors.approval_remark}</FormFeedback>
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Col md="3">
                                Verification
                            </Col>
                            <Col md="9" className="pull-right">
                                <Recaptcha
                                    sitekey="6LcxpLIaAAAAAEtUCw_EyxCTyE3md_B5WrHbv4vL"
                                    render="explicit"
                                    theme="light"
                                    size="compact"
                                    verifyCallback={(response) => { setFieldValue("recaptcha", response); }}
                                    onloadCallback={() => { console.log("done loading!"); }}
                                />
                                {errors.recaptcha 
                                && touched.recaptcha && (
                                <p>{errors.recaptcha}</p>
                                )}
                            </Col>
                        </FormGroup>
                        <FormGroup row className="pull-right">
                            
                            <Button type="button" onClick={handleSubmit} color="primary" className="mr-1" disabled={isSubmitting || !isValid}>{isSubmitting ? 'Wait...' : 'Submit'}</Button>&nbsp;&nbsp;
                            {/* <Button type="button" color="warning" className="mr-1" disabled={isSubmitting} onClick={this.toggleCloseAdd}>Close</Button> */}
                            {/* <Button type="reset" color="danger" className="mr-1" disabled={isSubmitting} onClick={handleReset}>Reset</Button> */}
                        </FormGroup>
                    </form>
                    )}
                />
            </div>
        )
    }

    showSuccess = () => {
        return (
            <div>
                <Alert color="success">
                    You've completed the delivery confirmation. Thank you for using automa.id platform.
                </Alert>
            </div>
        )
    }

    render() {
        const { customerApprovalStatus } = this.props;
        return (
            <div>
                <Row>
                    <Col md="12">
                        <Card>
                            <CardBody>
                            {
                                customerApprovalStatus ?
                                this.showSuccess()
                                :
                                this.showForms()
                            }
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

DeliveryConfirmationForms.propTypes = propTypes;
DeliveryConfirmationForms.defaultProps = defaultProps;

export default DeliveryConfirmationForms;


// WEBPACK FOOTER //
// ./src/views/Transporter/DeliveryConfirmation/DeliveryConfirmationForms.jsx